import { injectable } from 'inversify';

@injectable()
export class MemeUploadService {

    canvastoFile(canvas: HTMLCanvasElement): File {
        const dataURI = canvas.toDataURL('image/jpeg');
        // convert the data URL to a byte string
        const byteString = atob(dataURI.split(',')[1]);

        // pull out the mime type from the data URL
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // Convert to byte array
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        let filename = 'file';
        // Figure out what extension the file should have
        switch (mimeString) {
            case 'image/jpeg':
                filename = 'meme.jpg';
                break;
            case 'image/png':
                filename = 'meme.png';
                break;
        }

        return new File([ia], filename, { type: mimeString, lastModified: new Date().getTime() });
    }
}
